import { render, staticRenderFns } from "./CoMultiSelect.vue?vue&type=template&id=3f6f9ffe&scoped=true&"
import script from "./CoMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./CoMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CoMultiSelect.vue?vue&type=style&index=0&id=3f6f9ffe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f9ffe",
  null
  
)

export default component.exports